// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {

    //applicationName: 'Secure Swift',
    //applicationName: 'Transfer Smart',
    applicationName: 'Cockroach',

    production: false,
    encryptionKey: '',
    timeOut: '1800',

    //gateway_url: 'http://165.99.223.68:3394/BugsTs/api/v1/'
    gateway_url: 'https://cockroachts.in/BugsTs/api/v1/',

    //gateway_url: 'http://localhost:8080/api/v1/',

  
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
